const HTML_ENTITIES = {
  amp: '&', apos: "'", gt: '>', lt: '<', nbsp: ' ', quot: '"', pound: '£',
};

const decodeHtmlEntities = value => value.replace(/&(#x?[0-9a-f]+|[a-z]+);/gi, (match, entity) => {
  const normalized = entity.toLowerCase();
  if (normalized.startsWith('#x')) {
    const codePoint = Number.parseInt(normalized.slice(2), 16);
    return Number.isFinite(codePoint) ? String.fromCodePoint(codePoint) : match;
  }
  if (normalized.startsWith('#')) {
    const codePoint = Number.parseInt(normalized.slice(1), 10);
    return Number.isFinite(codePoint) ? String.fromCodePoint(codePoint) : match;
  }
  return HTML_ENTITIES[normalized] ?? match;
});

export const cleanSourceText = value => {
  if (!value) return '';
  return decodeHtmlEntities(String(value)
    .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, ' ')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(?:p|div|h[1-6]|ul|ol|li)>/gi, '\n')
    .replace(/<li\b[^>]*>/gi, '• ')
    .replace(/<[^>]+>/g, ' '))
    .replace(/\u00a0/g, ' ')
    .replace(/[ \t]+/g, ' ')
    .replace(/ *\n */g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

const normalizeForComparison = value => cleanSourceText(value).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

export const createJobCardSummary = (description, title, maxLength = 220) => {
  const clean = cleanSourceText(description);
  if (!clean) return '';
  const normalizedTitle = normalizeForComparison(title);
  const usefulLines = clean.split('\n').map(line => line.replace(/^[•-]\s*/, '').trim()).filter(line => {
    if (!line) return false;
    const normalizedLine = normalizeForComparison(line);
    if (normalizedLine === normalizedTitle) return false;
    if (/^(?:salary|pay|hourly rate|rate)\s*:/i.test(line)) return false;
    if (/^(?:£|gbp\s*)?[\d,.]+(?:\s*[-–]\s*(?:£|gbp\s*)?[\d,.]+)?(?:\s*(?:per\s+\w+|p\/?[ahd]))?$/i.test(line)) return false;
    return normalizedLine.length >= 20;
  });
  const summary = usefulLines.join(' ') || clean.replace(/\s+/g, ' ');
  if (summary.length <= maxLength) return summary;
  const shortened = summary.slice(0, maxLength + 1);
  const lastBoundary = Math.max(shortened.lastIndexOf('. '), shortened.lastIndexOf('! '), shortened.lastIndexOf('? '));
  if (lastBoundary >= Math.floor(maxLength * 0.55)) return shortened.slice(0, lastBoundary + 1);
  const lastSpace = shortened.lastIndexOf(' ');
  return `${shortened.slice(0, lastSpace > 0 ? lastSpace : maxLength).trim()}…`;
};

export const getListingDisplayDate = (dateAdded, fallbackDate, sourceType = '') => {
  const candidate = new Date(dateAdded);
  const fallback = new Date(fallbackDate);
  if (Number.isNaN(candidate.getTime())) return Number.isNaN(fallback.getTime()) ? null : fallback;
  if (!['reed', 'adzuna'].includes(sourceType)) return candidate;
  if (Number.isNaN(fallback.getTime())) return candidate;
  const oneDay = 24 * 60 * 60 * 1000;
  const tooOld = fallback.getTime() - candidate.getTime() > 45 * oneDay;
  const inFuture = candidate.getTime() > fallback.getTime() + oneDay;
  return tooOld || inFuture ? fallback : candidate;
};
